import type { ReactNode } from "react";
import { QRCodeSVG } from "qrcode.react";

/**
 * Client-side QR code rendered as an inline SVG, sharp at any print size with no network round-trip.
 *
 * It wraps `qrcode.react`'s `QRCodeSVG`, so the apps depend on one shared
 * primitive rather than the vendor import. `url` is the encoded value, `size`
 * the edge length in pixels, and `title` the SVG's accessible name. Error
 * correction level `"M"` recovers about 15% damage, enough for a printed code
 * that picks up smudges.
 */
export interface QrCodeProps {
  url: string;
  size?: number;
  className?: string;
  title?: string;
}

export function QrCode({ url, size = 200, className, title = "QR code" }: QrCodeProps): ReactNode {
  return (
    <QRCodeSVG
      value={url}
      size={size}
      level="M"
      marginSize={2}
      title={title}
      className={className}
    />
  );
}
